// extracted by mini-css-extract-plugin
module.exports = {"menu":"V_cH","menuWrapper":"V_cJ","subMenu":"V_cK","active":"V_S","open":"V_cL","close":"V_bN","audioIcon":"V_cM","icon":"V_bJ","activeSub":"V_cN"};